'use client';

import { Box, HStack, VStack, token } from '@terra/ui-styled-system';
import { CancelCircleIcon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { Badge } from '../../../../components/badge';
import { BodyDefault, HeadingItem } from '../../../../components/typography';
import type { SkipAttackReasonType } from '../../../traces/trace-types';
import { getBlockedExecutionCopy } from '../utils/blocked-execution-copy';

export type TraceBlockedEmptyStateProps = {
  reason: string;
  skipAttackReasonType?: SkipAttackReasonType;
};
export function TraceBlockedEmptyState({
  reason,
  skipAttackReasonType,
}: TraceBlockedEmptyStateProps) {
  const t = useTranslations('designSystem.executions');
  const { title, badge } = getBlockedExecutionCopy({
    skipAttackReasonType,
    t: (key) => t(key),
  });

  return (
    <Box w="full" p={4} overflowY="auto">
      <VStack gap={3} alignItems="stretch" w="full">
        <HStack gap={2} alignItems="center">
          <CancelCircleIcon
            size={14}
            color={token('colors.fg.neutral.default')}
            aria-hidden
          />
          <HeadingItem>{title}</HeadingItem>
          <Badge size="sm" variant="outline">
            {badge}
          </Badge>
        </HStack>
        <Box
          p={4}
          borderRadius="md"
          bg="bg.subtle"
          borderWidth="1px"
          borderColor="border.default"
        >
          <BodyDefault color="fg.default" lineHeight="1.6">
            {reason}
          </BodyDefault>
        </Box>
      </VStack>
    </Box>
  );
}
